<template>
    <div class="top-deals-container">
        <h2 class="h2">{{$t('top_deals')}}</h2>

        <!-- 标题列表 -->
        <ul class="city-list">
            <li class="list-item" v-for="(item) in cityList" :key="item.city_code">
                <div
                    class="list-item-inner"
                    :class="{
                    'list-item-active': item.city_code === cityCode
                }"
                    @click="select(item)"
                >{{item.title}}</div>
            </li>
        </ul>

        <!-- 城市对应的酒店列表 -->
        <ul class="hotel-list">
            <top-deals-hotel
                v-for="(hotel, index) in cityHotelList"
                :key="index"
                v-bind="hotel"
                :cityGis="cityGis"
                @click.native="linkTo(hotel)"
            />
        </ul>
    </div>
</template>

<script>
import TopDealsHotel from "./TopDealsHotel.vue";
import { linkTo } from "@/lib/utils";
import { mapGetters } from "vuex";
import { topdealsGtag } from "@/lib/gtag.js";

export default {
    components: {
        TopDealsHotel
    },
    data() {
        return {
            cityHotel: {}, //城市对应的酒店列表
            cityList: [], //城市列表
            cityCode: "",
            cityGis: []
        };
    },
    computed: {
        ...mapGetters(["hotelDater", "guests"]),
        cityHotelList() {
            return this.cityHotel[this.cityCode];
        }
    },
    created() {
        this.getTopDeals();
    },
    methods: {
        /**
         * 获取精选酒店数据
         */
        getTopDeals() {
            this.$req.get("v2/topDeals").then(({ data }) => {
                if (data.code === "2000") {
                    this.cityList = data.data.tip_title;
                    if (this.cityList) {
                        this.cityCode = this.cityList[0].city_code;
                        this.cityGis = [
                            this.cityList[0].lat,
                            this.cityList[0].lon
                        ];
                    }
                    this.setHotelList(data.data.list);
                }
            });
        },

        /**
         * 切换城市
         * @param {*} item 城市包含的字段，如city_code
         */
        select(item) {
            this.cityCode = item.city_code;
            this.cityGis = [item.lat, item.lon];
        },

        /**
         * 跳转至新页面
         * @param {*} hotel 酒店
         */
        linkTo(hotel) {
            //埋点
            topdealsGtag({
                酒店所属城市: hotel.city_name,
                酒店名称: hotel.hotel_name,
                酒店ID: hotel.hotel_code
            });

            this.$store
                .dispatch("searchHotelData", {
                    des: {
                        cityName: hotel.city_name,
                        countryName: hotel.country_name,
                        hotelItemCode: hotel.hotel_code,
                        hotelName: hotel.hotel_name
                    },
                    dater: {
                        startDate: this.hotelDater.startDate,
                        endDate: this.hotelDater.endDate
                    }
                })
                .then(() => {
                    linkTo(
                        `/hotel/detail/${hotel.hotel_code}/main?startdate=${this.hotelDater.startDate}&enddate=${this.hotelDater.endDate}&room=${this.guests.room}`
                    );
                });
        },

        /**
         * 设置城市对应的酒店列表
         */
        setHotelList(list) {
            if (!list || list.length === 0) {
                return;
            }

            //归类citycode
            let keys = {};

            //整理cityCode对应的酒店列表
            list.forEach(city => {
                //不存在时添加相应的city key
                if (!keys[city.city_code]) {
                    keys[city.city_code] = [];
                }
                keys[city.city_code].push(city);
            });

            //暂时处理成必须为4的倍数，目的是为了让flex效果生效
            for (let key in keys) {
                let data = keys[key];
                let offsetSize = data.length % 4;
                if (offsetSize === 1 && data.length > 3) {
                    /* 多出来一个则删除 */
                    data.pop();
                } else {
                    data.push(...new Array(4 - offsetSize));
                }
            }

            this.cityHotel = keys;
        }
    }
};
</script>

<style lang="scss" scoped>
.top-deals-container {
    .h2 {
        font-size: 36px;
        font-weight: 500;
        margin-bottom: 50px;
        margin-top: 80px;
        text-align: center;
    }

    .hotel-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .city-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;

        .list-item {
            flex: 1;
            box-sizing: border-box;
            padding-right: 32px;

            &:last-child {
                padding-right: 0;
            }

            .list-item-inner {
                box-sizing: border-box;
                border: 1px solid #c5c5c5;
                border-radius: 5px;
                line-height: 50px;
                font-size: 18px;
                text-align: center;
                transition: all ease-in-out 0.3s;
                cursor: pointer;
            }

            .list-item-inner:hover,
            .list-item-active {
                border-color: #00a9ba;
                color: #02909e;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/TopDeals.vue